import { inject, ref, computed, openBlock, createElementBlock, normalizeClass, createElementVNode, createTextVNode, toDisplayString, createVNode, renderSlot } from "vue";
import { incrementalId } from "../../uikit.helpers/incrementalId.es.js";
import UikitChevronIcon from "../../uikit.icons/ChevronIcon.vue.es.js";
/* empty css                       */
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "body" };
const _sfc_main = {
  __name: "AccordionPanel",
  props: {
    title: {
      type: String,
      required: true
    },
    id: {
      type: String,
      default: null
    }
  },
  emits: ["panelActivated"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const activePanelId = inject("activePanelId", null);
    const togglePanel = inject("togglePanel");
    const uniqID = ref(props.id ?? incrementalId());
    const isActive = computed(() => activePanelId.value === uniqID.value);
    const handleTitleClick = () => {
      togglePanel(uniqID.value);
      emit("panelActivated", uniqID.value);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: uniqID.value,
        class: normalizeClass(["uikit-accordion-panel", { "is-active": isActive.value }])
      }, [
        createElementVNode("div", {
          class: "header",
          onClick: handleTitleClick
        }, [
          createTextVNode(toDisplayString(__props.title) + " ", 1),
          createVNode(UikitChevronIcon, {
            type: isActive.value ? "up" : "down"
          }, null, 8, ["type"])
        ]),
        createElementVNode("div", _hoisted_2, [
          renderSlot(_ctx.$slots, "default")
        ])
      ], 10, _hoisted_1);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=AccordionPanel.vue.es.js.map
